import { defineComponent as _defineComponent } from 'vue'
import { MessageService } from '@/admin-shared-modules/utils/message.service'
import { useEdit, useList, useRemove } from '@/hooks'
import moment from 'moment'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const query = ref({ year: moment() })

const { listState, items, refetch } = useList({
  url: computed(() => `/api/monthly_records/list`),
  query: computed(() => ({
    year: moment(query.value.year).format('YYYY')
  }))
})

const { isEdit, formData, editState, onAdd, onEdit, onSubmit } = useEdit({
  submit: {
    url: computed(() =>
      isEdit.value
        ? `/api/monthly_records/modify/${formData.value.id}`
        : `/api/monthly_records/add`
    ),
    post: refetch
  }
})

const { onRemove, removeState } = useRemove({
  url: computed(() => `/api/monthly_records/${removeState.params.id}`),
  post: refetch
})

const editForm = ref(null)
const uploading = ref(false)

function onAddClick() {
  onAdd({
    year: moment(query.value.year).format('YYYY'),
    month: null,
    count: null,
    list_file: null,
    list_file_name: null
  })
}

// Define validation rules
const rules = {
  month: [{ required: true, message: '请选择月份' }],
  count: [{ required: true, message: '请填写更新图书数' }],
  list_file: [{ required: true, message: '请上传文件' }]
}

function beforeUpload(file) {
  uploading.value = true
  formData.value.list_file_name = file.name
  return true
}

function handleFileUploadSuccess(response) {
  formData.value.list_file = response.data.url
  uploading.value = false
  MessageService.open({
    type: 'success',
    message: '文件上传成功'
  })
  editForm.value.clearValidate()
}

function handleFileUploadError() {
  uploading.value = false
  MessageService.open({
    type: 'error',
    message: '文件上传失败'
  })
}

function handleFormSubmit() {
  editForm.value.validate(valid => {
    if (valid) {
      onSubmit()
    } else {
      MessageService.open({
        type: 'error',
        message: '请填写完整的表单'
      })
    }
  })
}

return { __sfc: true,query, listState, items, refetch, isEdit, formData, editState, onAdd, onEdit, onSubmit, onRemove, removeState, editForm, uploading, onAddClick, rules, beforeUpload, handleFileUploadSuccess, handleFileUploadError, handleFormSubmit }
}

})